// app.common/campaignPhoneOverride.service.js
(function () {
  'use strict';
  angular.module('app.common')
    .factory('campaignPhoneOverride', ['$window', '$sessionStorage', function ($window, $sessionStorage) {

        var PHONE_BY_SEO = {
            'cincinnati/ohio': '5138959309',
            'cincinnati-area/ohio': '5138959309',
            'northern-kentucky': '8596614322',
            'atlanta/georgia': '4049483134',
            'columbus/ohio': '6146298710',
            'indianapolis/indiana': '3174746590',
            'dayton/ohio': '9378843833',
            'st-louis/missouri': '3148040164',
            'northwest-florida': '8503679510',
            'louisville-area/kentucky': '5029066185',
            'louisville/kentucky': '5029066185',
            'southern-indiana' : '5029066185',
        };

        var KEY = '2060DigitalCampaignReferral';

        function getRegionSeoFromCampaign() {
            var params = new URLSearchParams($window.location.search);
            var campaign = params.get('utm_campaign') || '';
            if (!campaign) return null;

            var token = campaign.split('_')[0].toUpperCase();

            var TOKEN_TO_SEO = {
                CINCY: 'cincinnati/ohio',
                NKY:   'northern-kentucky',
                ATL:   'atlanta/georgia',
                CBUS:  'columbus/ohio',
                INDY:  'indianapolis/indiana',
                DAYTON:'dayton/ohio',
                STL:   'st-louis/missouri',
                PCB:   'northwest-florida',
                LOU:   'louisville-area/kentucky',
            };

            return TOKEN_TO_SEO[token] || null;
        }

        function has2060Utm() {
            var params = new URLSearchParams($window.location.search);
            var blobFromParams = ((params.get('utm_id')||'') + (params.get('utm_source')||'') +
                        (params.get('utm_medium')||'') + (params.get('utm_campaign')||'')).toLowerCase();
            return blobFromParams.indexOf('2060digital') !== -1;
        }

        function initFromUrl() {
            if (has2060Utm()) $sessionStorage[KEY] = { active: true, ts: Date.now() };
        }

        function isActive() {
            return !!($sessionStorage[KEY] && $sessionStorage[KEY].active);
        }

        function getOverridePhoneForCurrentRegion() {
            if (!isActive()) return null;

            var region = $sessionStorage.region;
            var seo = region && region.seo_name ? region.seo_name.toLowerCase() : null;

            if (!seo) seo = getRegionSeoFromCampaign();

            return seo ? PHONE_BY_SEO[seo] || null : null;
        }

        function clear() { delete $sessionStorage[KEY]; }

        return { initFromUrl, isActive, getOverridePhoneForCurrentRegion, clear };
    }])

    .run(['campaignPhoneOverride', function (campaignPhoneOverride) { campaignPhoneOverride.initFromUrl(); }]);
}());
